import { render, staticRenderFns } from "./StatisticsChartEmployeeSalary.vue?vue&type=template&id=1a771c4b&scoped=true"
import script from "./StatisticsChartEmployeeSalary.vue?vue&type=script&lang=js"
export * from "./StatisticsChartEmployeeSalary.vue?vue&type=script&lang=js"
import style0 from "./StatisticsChartEmployeeSalary.vue?vue&type=style&index=0&id=1a771c4b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a771c4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1a771c4b')) {
      api.createRecord('1a771c4b', component.options)
    } else {
      api.reload('1a771c4b', component.options)
    }
    module.hot.accept("./StatisticsChartEmployeeSalary.vue?vue&type=template&id=1a771c4b&scoped=true", function () {
      api.rerender('1a771c4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeStatistics/StatisticsChartEmployeeSalary.vue"
export default component.exports